// extracted by mini-css-extract-plugin
module.exports = {"container-guide":"game-guide_container-guide__ibiUu","guide-iframe":"game-guide_guide-iframe__CXyvw","guide-loading":"game-guide_guide-loading__tW86p"};